import _ from "lodash";
import { FieldValues, UseFormSetValue } from "react-hook-form";

import { IStationPriceAdditionDto } from "@ryde/shared";

export const normalizeStationAdditionFieldData = (
  watchedList: unknown,
  fieldName: string,
  setValue: UseFormSetValue<FieldValues>,
): IStationPriceAdditionDto[] => {
  if (watchedList && !_.isArray(watchedList)) {
    /* guard for invalid value coming from backend*/
    setValue(fieldName, []);
    return [];
  }

  return (watchedList || []) as IStationPriceAdditionDto[];
};
